import { Environment } from './environment.interface';
import pkg from '../../package.json';
import { format } from 'date-fns';

const urlBaseAPI = 'https://apis.brasilcap.info/b2cap/v1/';

export const environment: Environment = {
  version: '4.0.0-build.1789476365',
  buildTime: '15/09/2026',
  production: true,
  ambiente: 'dev',
  urlBaseAPI: urlBaseAPI,
  idCanalBNB: 2,
  idCanalCapfiador: 12,
  urlCEP: [
    'https://viacep.com.br/ws/{cep}/json/',
    'https://opencep.com/v1/{cep}'
  ],
  codConvenio: 2774925473,
  constantes: {
    TIPOS_CONTRATACAO: {
      VENDA: 2,
      TITULO: 1
    },
    ID_CANAL_SOLICITACAO: 10,
    PAGINATOR: {
      DEFAULT_PAGE_SIZE: 10,
      DEFAULT_PAGE_SIZE_OPTIONS: [5, 10, 25, 100]
    },
    VENDA_SITUACAO: {
      AGUARDANDO_PRIMEIRO_DEBITO: 6,
      COBRANCA_ENVIADA: 9
    },
    COBRANCA_PIX_STATUS_REGERAVEIS: ['CANCELADO', 'NÃO PAGO']
  },
  parceiros: {
    BNB: {
      id: 1, title: 'BNB'
    },
    BRASILCAP: {
      id: 2, title: 'BRASILCAP'
    },
    BB: {
      id: 3, title: 'BB'
    },
    PROMOTIVA: {
      id: 4, title: 'PROMOTIVA'
    },
    CANETAO: {
      id: 5, title: 'CANETAO'
    },
    BANRISUL: {
      id: 6, title: 'BANRISUL'
    },
    CAPFIADOR: {
      id: 17, title: 'CAPFIADOR'
    },
    IDEE: {
      id: 18, title: 'IDEE'
    },
    O2: {
      id: 19, title: 'O2'
    }
  },
  listaBandeiras: [
    { id: '001', desc: 'Visa' },
    { id: '002', desc: 'Master' },
    { id: '007', desc: 'Elo' }
  ],
  statusPedido: [
    { id: 1, desc: 'Criado' },
    { id: 2, desc: 'Processando números' },
    { id: 3, desc: 'Erro no processamento' },
    { id: 4, desc: 'Aguardando arquivo de vendas' },
    { id: 5, desc: 'Finalizado' }
  ],
};
